import React, { Component, CSSProperties } from 'react';

import { ListQuestionsExerciseLayout } from '../index'
import { IQuestionEditor } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';

interface IListQuestionsExerciseComponentProps {
    questions: IQuestionEditor[]
    editState?: boolean
    showStats?: boolean
    hideNewQuestion?: boolean
    hideEditButton?: boolean
    hideViewButton?: boolean
    hideValue?: boolean
    showDelete?: boolean
    idContainerQuestions?: string
    className?: string
    style?: CSSProperties
    onClickQuestion?: (question: IQuestionEditor)=>void
    onReorderQuestions?: (questions: IQuestionEditor[])=>void
    onClickView?: (question: IQuestionEditor)=>void
    onClickDelete?: (question: IQuestionEditor)=>void
    onClickEdit?: (question: IQuestionEditor, parent?: IQuestionEditor)=>void
    onClickNewQuestion?: (parent: string)=>void
    onChangeQuestions?: (questions: IQuestionEditor[])=>void
    onNextPage?: () => any
}

interface IListQuestionsExerciseComponentState {}

class ListQuestionsExerciseComponent extends Component<IListQuestionsExerciseComponentProps, IListQuestionsExerciseComponentState> {
    render() {
        return (
            <ListQuestionsExerciseLayout
                {...this.props}
            />
        );
    }
}

export default ListQuestionsExerciseComponent;
